import {ReduceStore} from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { UiLockActions } from '../constants/ui_lock/ui_lock_actions';

class UiLockStoreClass extends ReduceStore {
    getInitialState() {
        return false;
    }

    reduce(state, {source, action}) {
        const { type } = action;

        if (source === ACTION_TYPES.UI_LOCK_ACTION) {
            switch (type) {
                case UiLockActions.SHOW_ACTION:
                    if (!state) {
                        state = true;
                        this.__emitChange();
                    }
                    break;

                case UiLockActions.HIDE_ACTION:
                    if (state) {
                        state = false;
                        this.__emitChange();
                    }
                    break;
            }
        }

        return state;
    }
}

const UiLockStore = new UiLockStoreClass(Dispatcher);
export { UiLockStore };